<template>
  <div class="page-root" id="formMangement">
    <div class="horizontal-scroll" id="formMangement-horizontal-scroll">
      <div class="jumbotron" id="formMangement-jumbotron">
        <div class="container-fluid almost-fluid" id="formMangement-container">
          <div class="row" id="formMangement-row">

            <div class="col-4 col-lg-3" id="formMangement-dropdown">
              <select class="form-control" v-model="selectedConfigType" name="product_line" id="import_type" required>
                <template v-for="product in enabledProducts">
                  <option :key="product.name" :value="product.name + '_JSON'" :id="'oldProduct-' + product.name">
                    {{ product.description }} {{ 'SUFFIX_DEFAULT' | translate('productLine') }}
                  </option>
                </template>
                <template v-for="productLine in enabledProductLines">
                  <option :key="productLine.name" :value="productLine.name + '_JSON'"
                    :id="'oldProductLine-' + productLine.name">
                    {{ productLine.description }} {{ 'SUFFIX_DEFAULT' | translate('productLine') }}
                  </option>
                  <option :key="productLine.name + '_NEW'" :value="productLine.name + '_NEW'"
                    :id="'newProductLine-' + productLine.name">
                    {{ productLine.description }} {{ 'SUFFIX_NEW' | translate('productLine') }}
                  </option>
                </template>

                <option value="CUSTOMER" id="formMangement-customerFormConfig">
                  {{ 'CUSTOMER_FORM_CONFIGURATION' | translate() }}
                </option>
              </select>
            </div>

            <div class="col-auto" id="formMangement-buttons">
              <button class="btn btn-primary icon-button icon-button-collapsed"
                v-tooltip="$options.filters.translate('DOWNLOAD')" :disabled="!selectedConfigType && !loaded"
                @click="triggerDownload" id="formMangement-downloadButton">
                <span class="btn-icon" id="formMangement-downlaodSpan"><i class="fa fa-download" aria-hidden="true"
                    id="formMangement-download-data"></i></span>
              </button>

              <button class="btn btn-primary icon-button icon-button-collapsed"
                v-tooltip="$options.filters.translate('LOAD_DEFAULT')" :disabled="!loaded"
                @click="showConfirmDialogOverwriteCurrent = true" id="formMangement-loadDefaultButton">
                <span class="btn-icon" id="formMangement-loadDefaultButton-span"><i class="fa fa-history"
                    aria-hidden="true" id="formMangement-loadDefaultButton-data"></i></span>
              </button>

              <button class="btn btn-success icon-button icon-button-collapsed"
                v-tooltip="$options.filters.translate('STORE_CURRENT_AS_DEFAULT')" :disabled="!loaded"
                @click="showConfirmDialogOverwriteDefault = true" id="formMangement-storeCurrentAsDefaultButton">
                <span class="btn-icon" id="formMangement-storeCurrentAsDefaultButton-span"><i class="fa fa-check"
                    aria-hidden="true" id="formMangement-storeCurrentAsDefaultButton-data"></i></span>
              </button>

              <button class="btn btn-success icon-button icon-button-collapsed" v-if="selectedConfigType && selectedConfigType.endsWith('_NEW')"
                v-tooltip="$options.filters.translate('GENERATE_TEMPLATE')" :disabled="!loaded"
                @click="showConfirmDialogGenerateTemplate = true" id="formMangement-generateTemplatetButton">
                <span class="btn-icon" id="formMangement-generateTemplatetButton-span"><i class="fa fa-file-excel-o"
                    aria-hidden="true" id="formMangement-generateTemplatetButton-data"></i></span>
              </button>
            </div>

            <div class="col-6 col-xl-4 ml-auto" id="formMangement-uploadLayout">
              <form v-on:submit.prevent="submitForm()" id="formMangement-form">
                <div class="form-group mb-0" id="formMangement-formGroup">
                  <div class="form-row" id="formMangement-formRow">
                    <div class="col" id="formMangement-formcolumn">
                      <div class="custom-file" id="formMangement-customFile">
                        <input type="file" class="custom-file-input" id="import_file" name="import_file"
                          ref="fileupload" v-on:change="selectFile" accept="application/json" required>
                        <label class="custom-file-label" for="import_file" id="formMangement-customFile-label">
                          {{ (file && file.name) ? file.name : 'UPLOAD_CONFIGURATION_FILE' | translate }}
                        </label>
                      </div>
                    </div>
                    <div class="col-auto" id="formMangement-uploadLayout-submit">
                      <button type="submit" v-if="!submitting" class="btn btn-primary icon-button icon-button-collapsed"
                        v-tooltip="$options.filters.translate('SUBMIT')" id="formMangement-uploadLayout-submitButton">
                        <span class="btn-icon" id="formMangement-uploadLayout-submitButton-span"><i class="fa fa-upload"
                            aria-hidden="true" id="formMangement-uploadLayout-submitButton-data"></i></span>
                      </button>
                      <img src="/static/loader-tail.svg" width="30" alt="Loading..." v-else
                        id="formMangement-uploadLayout-submit-Image" />
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>

      <div class="builder-container" id="formMangement-builder-container">
        <div class="container-fluid almost-fluid" id="formMangement-conatiner-fluid">
          <div class="form-container policy-customer-form" id="formMangement-form-container">
            <form-builder ref="formBuilder" :form="selectedConfig" :options="builderOptions"
              @saveComponent="debouncedSaveConfig" @removeComponent="debouncedSaveConfig"
              id="formMangement-formBuilder-formIO"></form-builder>
          </div>
        </div>
      </div>

      <div class="cm-container">
        <div class="cm-loader" v-if="!loaded">
          <custom-spinner></custom-spinner>
        </div>
      </div>
    </div>

    <confirm-dialog :show="showConfirmDialogUpload" :textLabel="'msg.SURE_OVERWRITE_CONFIGURATION_UPLOAD'"
      @hide-dialog="showConfirmDialogUpload = false, file = '', $refs.fileupload.value = null;"
      @confirm="overwriteConfig">
    </confirm-dialog>
    <confirm-dialog :show="showConfirmDialogOverwriteCurrent" :textLabel="'msg.SURE_OVERWRITE_CURRENT_CONFIGURATION'"
      @hide-dialog="showConfirmDialogOverwriteCurrent = false" @confirm="loadDefaultAndSave">
    </confirm-dialog>
    <confirm-dialog :show="showConfirmDialogOverwriteDefault" :textLabel="'msg.SURE_OVERWRITE_DEFAULT_CONFIGURATION'"
      @hide-dialog="showConfirmDialogOverwriteDefault = false" @confirm="promoteCurrentConfigurationsAsDefault">
    </confirm-dialog>
    <confirm-dialog :show="showConfirmDialogGenerateTemplate" :textLabel="'msg.GENERATE_TEMPLATE_MSG'"
      @hide-dialog="showConfirmDialogGenerateTemplate = false" @confirm="promoteImportTemplateGeneration">
    </confirm-dialog>
  </div>
</template>

<script>
import FormConfigService from '../../service/FormConfigService.js';
import GeneralConfigService from '../../service/GeneralConfigService';
import { FormBuilder } from 'vue-formio';
import RestService from '../../service/RestService';
import ConfirmDialog from '../dialog/ConfirmDialog';
import builderOptions from '../../formio-builder-options.json';
import _ from 'lodash';
import CustomSpinner from '../CustomSpinner.vue';

export default {
  components: { FormBuilder, ConfirmDialog, CustomSpinner },
  data() {
    return {
      rest: this.initRestService(),
      selectedConfigType: null,
      selectedConfig: null,
      draftConfig: null,
      enabledProductLines: null,
      enabledProducts: null,
      loaded: true,
      file: null,
      submitting: false,
      showConfirmDialogUpload: false,
      showConfirmDialogOverwriteCurrent: false,
      showConfirmDialogOverwriteDefault: false,
      showConfirmDialogGenerateTemplate: false,
      builderOptions: builderOptions
    }
  },
  async beforeMount() {
    await this.init();
  },
  created() {
    this.debouncedSaveConfig = _.debounce(this.saveConfig, 1000, { 'leading': true, 'trailing': false });
  },
  methods: {
    async init() {
      this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
      this.enabledProducts = await GeneralConfigService.getEnabledProducts();
      this.selectedConfigType = this.enabledProducts[0].name + '_JSON';
    },
    initRestService() {
      return new RestService();
    },
    saveConfig() {
      const builder = this.$refs['formBuilder'].builder;
      const schema = builder && builder.instance ? builder.instance.schema : {};
      const updatedSchema = this.draftConfig || schema;
      const updatedSchemaStringified = JSON.stringify(updatedSchema);
      this.loaded = false;
      this.rest.uploadConfigFile(this.selectedConfigType, updatedSchemaStringified)
        .then((response) => {
          FormConfigService.updateFormConfig(this.selectedConfigType, updatedSchemaStringified);
          this.selectedConfig = updatedSchema;
          this.draftConfig = null;
          this.submitting = false;
          setTimeout(() => {
            this.$refs['formBuilder'].initializeBuilder();
            this.loaded = true;
            this.$notify({
              type: 'alert-success',
              text: this.$options.filters.translate('CONFIGURATION_SAVED', 'msg')
            });
          }, 300);
        }).catch((err) => {
          this.loaded = true;
          let finalMessage = '';
          // 422 Unprocessable Entity if there are any validation errors
          if (err.response && err.response.status === 422) {
            let errors = err.response.data;
            errors.forEach((error) => { finalMessage += ('\n' + error) });
          } else if (typeof err.response !== 'undefined') {
            this.$log.error(err.response.data);
          } else {
            this.$log.error(err);
          }
          this.submitting = false;
          this.loaded = true;
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: this.$options.filters.translate('ERROR_SAVING_CONFIGURATION', 'msg') + '\n' + finalMessage
          });
        });
    },
    triggerDownload() {
      const url = window.URL.createObjectURL(new Blob([JSON.stringify(this.selectedConfig)]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${this.selectedConfigType}.json`);
      link.click();
      window.URL.revokeObjectURL(url);
    },
    loadDefaultAndSave() {
      this.showConfirmDialogOverwriteCurrent = false;
      this.loaded = false;
      let configType = this.selectedConfigType;
      this.rest.getDefaultConfigForm(configType)
        .then((response) => {
          this.selectedConfig = response.data;
          this.draftConfig = response.data;
          this.debouncedSaveConfig();
          setTimeout(() => {
            this.$notify({
              type: 'alert-success',
              text: this.$options.filters.translate('LOADED_DEFAULT_CONFIGURATION', 'msg') +
                ' (' + this.$options.filters.translate(this.selectedConfigType, 'product') + ')'
            });
          }, 200); // this is the minimal loader time
        }).catch((err) => {
          if (typeof err.response !== 'undefined') {
            this.$log.error(err.response.data);
          } else {
            this.$log.error(err);
          }
          this.loaded = true;
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: this.$options.filters.translate('ERROR_LOADING_DEFAULT_CONFIGURATION', 'msg')
          });
        });
    },
    promoteImportTemplateGeneration() {
      this.showConfirmDialogGenerateTemplate = false;
      let configType = this.selectedConfigType;
      this.rest.generateImportTempalateFile(configType)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${configType}.xlsx`);
          link.click();
          window.URL.revokeObjectURL(url);
        }).catch((err) => {
          if (typeof err.response !== 'undefined') {
            this.$log.error(err.response.data);
          } else {
            this.$log.error(err);
          }
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: this.$options.filters.translate('ERROR_STORING_GENERATE_IMPORT_TEMPLATE', 'msg')
          });
        });
    },
    promoteCurrentConfigurationsAsDefault() {
      this.showConfirmDialogOverwriteDefault = false;
      let configType = this.selectedConfigType;
      this.rest.saveCurrentConfigurationsAsDefault(configType)
        .then((response) => {
          this.$notify({
            type: 'alert-success',
            text: this.$options.filters.translate('CURRENT_CONFIGURATIONS_SAVED_AS_DEFAULT', 'msg') +
              ' (' + this.$options.filters.translate(this.selectedConfigType, 'product') + ')'
          });
        }).catch((err) => {
          if (typeof err.response !== 'undefined') {
            this.$log.error(err.response.data);
          } else {
            this.$log.error(err);
          }
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: this.$options.filters.translate('ERROR_STORING_CURRENT_CONFIGURATIONS_AS_DEFAULT', 'msg')
          });
        });
    },
    submitForm() {
      this.submitting = true;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.draftConfig = JSON.parse(reader.result);
        this.showConfirmDialogUpload = true;
        this.submitting = false;
      }
      reader.onerror = (e) => {
        this.$log.error('Failed reading file: ' + e.message);
        this.submitting = false;
      }
      reader.readAsText(this.file);
    },
    selectFile(evt) {
      this.file = evt.target.files[0];
    },
    overwriteConfig() {
      this.selectedConfig = this.draftConfig;
      this.debouncedSaveConfig();
      this.showConfirmDialogUpload = false;
      this.file = '';
      this.$refs.fileupload.value = null;
    }

  },
  watch: {
    async selectedConfigType(newVal, oldVal) {
      this.loaded = false;
      let config = await FormConfigService.getFormConfig(newVal);
      this.selectedConfig = JSON.parse(config);
      setTimeout(() => { // ugly fix for builder not refreshing some fields correctly
        this.$refs['formBuilder'].initializeBuilder();
        this.loaded = true;
      }, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.jumbotron {
  position: relative;
  z-index: 3;
  padding-left: 0;
  box-shadow: 0 0 30px $white;

  .icon-button {
    margin-bottom: 0;
  }
}

.builder-container {
  height: calc(100% - 102px);
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/FormManagement.vue